function upperCase(working, command, p) {
  return working.text.toUpperCase();
}

// Meta
upperCase.key = "upper-case";
upperCase.title = "Upper Case";
upperCase.category = "Text Casing";
upperCase.docUrl = "https://deanebarker.net/tech/code/textflow-js/commands/upper-case/";
upperCase.description = "Convert the working text to uppercase.";
upperCase.args = [];
upperCase.parseValidators = [];

export default upperCase;
